// extracted by mini-css-extract-plugin
module.exports = {"root":"background_root__1gSGN","bgLoader":"background_bgLoader__3DU3z","custom":"background_custom__390ea","loading":"background_loading__X71aN"};